<template>
    <div class="vm-block-goal">
        <div class="fwb">{{$t('c.BlockGoal.text1')}}</div>
        <div class="fs12 black-5 mt8">{{$t('c.BlockGoal.text2')}}</div>
        <div v-if="sum_income_goal_list.length > 0">
            <div class="mt16 flex-box flex-justify-content-space-between flex-align-items-center fs12">
                <span class="black-5">{{$t('c.BlockGoal.text3')}}</span>
                <date-picker type="datetime" format="YYYY-MM-DD HH:mm" :placeholder="$t('c.BlockGoal.text4')" :editable="false" v-model="un_begin_time"></date-picker>
            </div>
             <div class="mt16 flex-box flex-justify-content-space-between flex-align-items-center fs12">
                <span class="black-5 flex-item-1">{{$t('c.BlockGoal.text5')}}</span>
                <date-picker type="datetime" format="YYYY-MM-DD HH:mm" :placeholder="$t('c.BlockGoal.text6')" :editable="false" v-model="un_end_time"></date-picker>
            </div>
        </div>
        <template v-for="(goal, i) in goal_list">
            <goal-edit
                v-if="goal.type == goal_type.sum_income"
                class="mt16"
                :key="i"
                :index="i"
                :goal="goal"
                :type="goal_type.sum_income"
                :begin_time="un_begin_time"
                :end_time="un_end_time"
                @save="save"
                @remove="remove(i)">
            </goal-edit>
        </template>
        <btn class="size40 w100 look2 mt16" @click.native="add(goal_type.sum_income)">{{$t('c.BlockGoal.text7')}}</btn>
        <div class="line mt-32-24 mq"></div>
        <div class="fwb mt-32-24 mq">{{$t('c.BlockGoal.text8')}}</div>
        <div class="fs12 black-5 mt8">{{$t('c.BlockGoal.text9')}}</div>
        <template v-for="(goal, i) in goal_list">
            <goal-edit
                v-if="goal.type == goal_type.sponsor"
                class="mt16"
                :key="i"
                :goal="goal"
                :index="i"
                :type="goal_type.sponsor"
                @save="save"
                @remove="remove(i)">
            </goal-edit>
        </template>
        <btn class="size40 w100 look2 mt16" @click.native="add(goal_type.sponsor)">{{$t('c.BlockGoal.text10')}}</btn>
        <div class="line mt-32-24 mq"></div>
        <div class="fwb  mt-32-24 mq">{{$t('c.BlockGoal.text11')}}</div>
        <div class="fs12 black-5 mt8">{{$t('c.BlockGoal.text12')}}</div>
        <template v-for="(goal, i) in goal_list">
            <goal-edit
                v-if="goal.type == goal_type.money"
                class="mt16"
                :key="i"
                :goal="goal"
                :index="i"
                :type="goal_type.money"
                @save="save"
                @remove="remove(i)">
            </goal-edit>
        </template>
        <btn class="size40 w100 look2 mt16" @click.native="add(goal_type.money)">{{$t('c.BlockGoal.text13')}}</btn>
        <div class="setting-card-box mt-48-32 mq">
            <div class="setting-card flex-box flex-justify-content-space-between flex-align-items-center">
                <div>{{$t('c.BlockGoal.text14')}}</div>
                <switches theme="custom" color="purple" v-model="is_sponsor_count_in"></switches>
            </div>
            <div class="setting-card flex-box flex-justify-content-space-between flex-align-items-center">
                <div>{{$t('c.BlockGoal.text15')}}</div>
                <switches theme="custom" color="purple" v-model="is_product_count_in"></switches>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'; //https://github.com/mengxiong10/vue2-datepicker/blob/master/README.zh-CN.md
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/zh-cn';
import {mapState} from 'vuex'
import { GET_ALL_GOALS, POST_GOAL_SETTING_SPONSOR, POST_GOAL_SETTING_PRODUCT } from '@/api/config'
export default {
    name: 'block-goal',
    data(){
        return {
            goal_count:1,
            t:new Date().getTime(),
            un_begin_time: 0,
            un_end_time: 0,
            is_sponsor_count_in:'',
            is_product_count_in:'',
            // begin_time:this.goal.begin_time ? new Date(this.goal.begin_time * 1000) : null,
            // end_time:this.goal.end_time ? new Date(this.goal.end_time * 1000) : null,
            // goal_list_sponsor:[],
            // goal_list_money:[],
        }
    },
    components:{
        DatePicker
    },
    computed:{
        ...mapState('app',[
            'session_user',
            'user_status',
            'goal_status',
            'goal_type',
            'goal_list',
            'goal_setting'
        ]),
        is_creator(){
            if(this.session_user && this.session_user.creator && this.session_user.creator.status){
                return true
            }
            return false
        },
        tit(){
            if(!this.is_creator){
                return '成为创作者'
            }
            return '设置'
        },
        sum_income_goal_list(){
            return this.goal_list.filter((v) => v.type == this.goal_type.sum_income)
        }
    },
    watch:{
        is_sponsor_count_in(newV,oldV){ 
            if(oldV !== ''){
                this.setting_sponsor(newV ? 1 : 0)
            }
        },
        is_product_count_in(newV,oldV){
            if(oldV !== ''){
                this.setting_product(newV ? 1 : 0)
            }
        },
        // goal_list(list){
            // this.goal_list_sponsor = []
            // this.goal_list_money = []
            // list.forEach((v, k) => {
            //     if(v.type == this.goal_type.sponsor){
            //         this.goal_list_sponsor.push(v)
            //     }
            //     if(v.type == this.goal_type.money){
            //         this.goal_list_money.push(v)
            //     }
            // })
        // }
    },
    async mounted(){
        await this.$store.dispatch('app/get:goal_list');
        

        this.$nextTick(() => {
            let list = this.goal_list;
            for(let i = 0; i < list.length; i++){
                let goal = list[i];
                if(goal.type == this.goal_type.sum_income){
                    this.un_begin_time = new Date(goal.begin_time * 1000)
                    this.un_end_time = new Date(goal.end_time * 1000)
                    break;
                }
            }
            if(this.goal_setting){
                this.is_sponsor_count_in = !!this.goal_setting.is_sponsor_count_in
                this.is_product_count_in = !!this.goal_setting.is_product_count_in
            }
        })
    },
    methods:{
        uid(){
            return 't' + Math.random()
        },
        add(type){
            this.goal_count++
            this.$store.dispatch('app/push:goal_list', {_id:this.goal_count,type:type});
        },
        remove(i){
            this.$store.dispatch('app/splice:goal_list', [i, 1]);
        },
        save(param){
            this.$store.dispatch('app/splice:goal_list', [param.index, 1, param.goal]);
        },
        async next(){
            if(this.$http.is_run(GET_ALL_GOALS)){
                return false
            }
            let data = await this.$http.$axios(GET_ALL_GOALS)

            if(data.ec != 200){
                this.$notify({
                    title: data.em,
                    group: 'error',
                })
            }
            if(this.is_creator && data.ec == 200){
                this.$notify({
                    title: data.em,
                    group: 'success',
                })
            }
            if(data.data.list.length != 0){
                this.$router.push({name: 'settingCollect'})
            }else{
                this.$notify({
                    title: '请最少填写一个目标方案',
                    group: 'error',
                })
            }
        },
        async setting_sponsor(status) {
            if (this.$http.is_run(POST_GOAL_SETTING_SPONSOR)) {
                return false;
            }
            let data = await this.$http.$axios(POST_GOAL_SETTING_SPONSOR, {
                status,
            });

            this.$notify({
                title: data.em,
                group: data.ec == 200 ? 'success' :"error",
            });
        },
        async setting_product(status) {
            if (this.$http.is_run(POST_GOAL_SETTING_PRODUCT)) {
                return false;
            }
            let data = await this.$http.$axios(POST_GOAL_SETTING_PRODUCT, {
                status,
            });

            this.$notify({
                title: data.em,
                group: data.ec == 200 ? 'success' :"error",
            });
        },
    }
};
</script>

<style lang="stylus" scoped>
.vm-block-goal{
    .setting-card-box{
        background: $white;
        border-radius: 5px;
    }
    .setting-card{
        padding:24px 16px;
    }
}
</style>
